import Swal from 'sweetalert2';
import i18n from '@/i18n/index'
const Toast = Swal.mixin({
    toast: true,
    position: 'top-right',
    showConfirmButton: false,
    timer: 4200,
    timerProgressBar: true
})
export function useAuthenticatedFetch() {
    const token = localStorage.getItem('authToken');
    const authenticatedFetch = async (url: string, options: RequestInit = {}, alert: boolean, customToastMessage: string | '', trace: boolean) => {
        const headers = new Headers(options.headers || {});

        if (token) {
            headers.set('Authorization', `Bearer ${token}`);
        }
        headers.set('Accept', 'application/json');
        headers.set('Content-Type', 'application/json');
        if (trace)
            headers.set('X-Trace', 'true');


        const response = await fetch(url, {
            ...options,
            headers,
        });
        if (!response.ok) {
            const responseJson = await response.json()
            if (response.status === 422) {

                let MessageError = ''
                let validatoreKey = ''
                let values = []
                let inputName = ''

                Object.keys(responseJson?.errors).forEach(function (attribute, index) {
                    responseJson?.errors[attribute]?.map((item, index) => {
                        // Split the string by dots
                        const parts = item.split('.');
                        validatoreKey = parts.slice(0, 2).join('.');
                        values = parts.slice(2) || [];

                        inputName = i18n.t("validator.attributes." + attribute)
                        MessageError = "- " + i18n.t("validator." + validatoreKey, { attribute: inputName, value: values[0] || null }) + "\n" + MessageError
                    })
                });

                Toast.fire({
                    title: MessageError,
                    icon: 'error',
                });
            } else if (response.status === 404) {

                Toast.fire({
                    title: i18n.t("message.not_found." + responseJson?.message + ".title"),
                    icon: 'error',
                });
            } else if (response.status === 500) {
                Toast.fire({
                    title: "erreur de connexion, essai plus tard ou actualisé votre page",
                    icon: 'error',
                });
            } else if (response.status === 400) {
                Toast.fire({
                    title: i18n.t("message.toast.invalidExtention." + responseJson?.message),
                    icon: 'error',
                });
            }
            throw new Error(`Request failed: ${response.statusText}`);
        } else {
            if (response.status === 201 && alert && options?.method === "POST") {
                if (customToastMessage !== '') {
                    Toast.fire({
                        title: customToastMessage,
                        icon: 'success',
                    });
                } else {
                    Toast.fire({
                        title: i18n.t("message.toast.add.title"),
                        icon: 'success',
                    });
                }
            }
            if (response.status === 200 && alert && options?.method === "DELETE") {
                Toast.fire({
                    title: i18n.t("message.toast.delete.title"),
                    icon: 'success',
                });
            }
            if (response.status === 200 && alert && options?.method === "PUT") {
                Toast.fire({
                    title: i18n.t("message.toast.edit.title"),
                    icon: 'success',
                });
            }
        }
        return response.json();
    };

    return { authenticatedFetch };
}
